module.exports = __webpack_public_path__ + "static/media/instagram.27a96ea6.svg";